import { IPagedResponse } from '@aex/ngx-toolbox';
import { PremiseApi } from '@aex/shared/apis';
import {
	AuthType,
	IClientPremise,
	ICustomerPremise,
	IPredefinedPremise,
	IPredefinedPremiseSearch, IPremiseHistory,
	ParamMetaData,
} from '@aex/shared/common-lib';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PremiseService {

	public customerId: string;

	constructor(
		private readonly http: HttpClient,
	) {
	}

	public searchPredefinedPremises(query: IPredefinedPremiseSearch): Observable<IPagedResponse<IPredefinedPremise>> {
		return this.http.get<IPagedResponse<IPredefinedPremise>>(PremiseApi.predefinedPremises, {
			params: new ParamMetaData({ handleError: 'premise', authToken: AuthType.PROXIED })
			.set('q', query.full_text),
		});
	}

	public getPredefinedPremise(predefinedPremiseID: string): Observable<IPredefinedPremise> {
		return this.http.get<IPredefinedPremise>(PremiseApi.predefinedPremiseByGuid(predefinedPremiseID), {
			params: new ParamMetaData({ handleError: 'premise', authToken: AuthType.PROXIED }),
		});
	}

	public existingCustomerPremise(predefinedPremiseGuid: string): Observable<IPagedResponse<ICustomerPremise>> {
		return this.http.get<IPagedResponse<ICustomerPremise>>(PremiseApi.getPremisesByExternalReference(predefinedPremiseGuid), {
			params: new ParamMetaData({ handleError: 'premise', authToken: AuthType.PROXIED }),
		});
	}

	public getClientPremises(predefinedPremiseID: string): Observable<IPagedResponse<IClientPremise>> {
		return this.http.get<IPagedResponse<IClientPremise>>(PremiseApi.clientPremisesByPredefinedPremisesGuid(predefinedPremiseID), {
			params: new ParamMetaData({ handleError: 'premise', authToken: AuthType.PROXIED }),
		});
	}

	public getPremiseHistory(premiseId: string): Observable<IPagedResponse<IPremiseHistory>> {
		return this.http.get<IPagedResponse<IPremiseHistory>>(
			`${PremiseApi.premiseHistory(premiseId)}?count=all`, {
				params: new ParamMetaData({ handleError: 'premise', authToken: AuthType.PROXIED }),
			});
	}

}
